module.exports = __webpack_public_path__ + "static/media/IntroToDocker.ee39c699.png";